import { render, staticRenderFns } from "./authorView.vue?vue&type=template&id=6823089c&scoped=true"
import script from "./authorView.vue?vue&type=script&lang=js"
export * from "./authorView.vue?vue&type=script&lang=js"
import style0 from "./authorView.vue?vue&type=style&index=0&id=6823089c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6823089c",
  null
  
)

export default component.exports